import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'signup',
  event_category: 'signup',
  event_action: null, // signups: email,sms
  event_label: null, // location of email signup
  event_value: '0',
  event_noninteraction: 'false'
};

function trackEmailSignup(_: string, eventData: IDataLayer = {}) {
  tealium.dataLayer.update(eventData);
  eventData.event_label = eventData.last_source || '';
  eventData.event_action = eventData.opt_in_state || '';
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('emailSignup', trackEmailSignup);
